export default __webpack_public_path__ + "static/media/banniere-25.d100ff11.png";